import { useQuery } from "@tanstack/react-query";
import { fetchAppointmentPaymentInfo } from "@/lib/services/appointmentModalService";

/**
 * React Query hook for fetching and caching appointment payment info.
 * @param id Appointment ID
 */
export function useAppointmentPaymentInfo(id: number) {
  return useQuery({
    queryKey: ["appointmentPaymentInfo", id],
    queryFn: () => fetchAppointmentPaymentInfo(id),
    staleTime: 1 * 60 * 1000, // 1 minutes, adjust as needed
  });
}
